import {I18n} from 'aws-amplify/utils';
import {Box} from '@mantine/core';
import {
    ReloadButton,
    SimplePageHeader,
} from '@flexinet/ui-components';

import {useHostedZones} from '../hooks/useHostedZones';
import config from '../config';

const HostedZonesReloadButton = () => {
    const {reload} = useHostedZones();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => reload()}/>
        </Box>
    );
};

const useTools = () => {
    // READ-ONLY module (FNP-973): no Add, no Edit, no Delete. The deployed
    // schema exposes no hosted-zone mutation to call — write operations are
    // FNP-977. Reload is the only tool, and that is deliberate rather than an
    // unfinished toolbar.
    return [<HostedZonesReloadButton key='reload'/>];
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get(config.titles.plural)}
            tools={useTools()}
        />
    );
};
